import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { ICO_ABI } from "../../Contract/ICO_ABI";
import { ICO_CONTRACT_ADDRESS } from "../../utils/constant";
import { toast } from "react-toastify";
import { useWriteContract, usePublicClient } from "wagmi";
import { useAppKitAccount } from "@reown/appkit/react";
import Loader from "../Loader/Loader";
import { isValidEVMAddress } from "../../utils/helper";
import { parseUnits } from "viem";
import { readContract } from "@wagmi/core";
import { config } from "../../config";


const AddFiatPurchaseModal = ({ show, handleClose }) => {
  const [buyer, setBuyer] = useState("");
  const [tokenAmount, setTokenAmount] = useState("");
  const [loading, setLoading] = useState(false);

  const { writeContractAsync } = useWriteContract();
  const { address } = useAppKitAccount();
  const publicClient = usePublicClient();

  const validateFields = () => {
    // Buyer address validation
    if (!buyer) {
      toast.error("Buyer address is required");
      return false;
    }
    if (!isValidEVMAddress(buyer)) {
      toast.error("Please enter a valid Ethereum address");
      return false;
    }

    // Token amount validation
   const token = parseFloat(tokenAmount);
    if (!tokenAmount) {
      toast.error("Token amount required");
      return false;
    }
    if (isNaN(token) || token <= 0) {
      toast.error("Token amount must be positive");
      return false;
    }
    if (token < 0.01) {
      toast.error("Minimum token amount is 0.01");
      return false;
    }

    return true;
  };

  const handleSave = async () => {
    if (!validateFields()) return;

    try {
      setLoading(true);

      const contractData = {
        abi: ICO_ABI,
        address: ICO_CONTRACT_ADDRESS,
        functionName: "addFiatPurchase",
        args: [
          buyer,
          parseUnits(tokenAmount, 18), // Smart contract expects only tokenAmount
        ],
      };

      // Pre-check revert reason
      await readContract(config, { ...contractData, account: address });

      const tx = await writeContractAsync(contractData);

      const receipt = await publicClient.waitForTransactionReceipt({ hash: tx });

      if (receipt?.status === "success") {
        toast.success("Fiat purchase added successfully");
        handleClose();
      }
    } catch (error) {
      console.log("add fiat purchase error", error);

      const revertReason =
        error?.cause?.reason ||
        error?.shortMessage ||
        error?.message ||
        "Something went wrong";

      toast.error(revertReason);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Fiat Purchase</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            {/* Buyer Address */}
            <Form.Group className="mb-3">
              <Form.Label>Buyer Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="0x..."
                value={buyer}
                onChange={(e) => setBuyer(e.target.value)}
              />
            </Form.Group>

            {/* Token Amount */}
            <Form.Group className="mb-3">
              <Form.Label>Token Amount</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter token amount"
                value={tokenAmount}
                onChange={(e) => setTokenAmount(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Cancel
          </Button>

            <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddFiatPurchaseModal;
